import {Repository} from "../../persistence/repository";
import {PersonalLabel} from "../entities/personal-label.entity";
import {singleton} from "tsyringe";
import {persistence} from "../../decorators/persistence.decorator";
import {plainToInstance} from "class-transformer";
import {PersonalLabelDto} from "../dtos/personal-label.dto";
import {EntityState} from "../../persistence/entity-state.enum";
import {ChangeTracker} from "../../change-tracking/change-tracker";
import {ShortIdHelper} from "../../helpers/short-id.helper";
import {ArrayHelper} from "../../helpers/array.helper";

@singleton()
@persistence({entity: PersonalLabel})
export class PersonalLabelRepository extends Repository<PersonalLabel> {

    public create(label: string): Promise<PersonalLabel> {
        const personalLabel = plainToInstance(PersonalLabel, <PersonalLabelDto>{
            uid: ShortIdHelper.generate(),
            label,
        });

        const personalLabelProxy = ChangeTracker.create(personalLabel);

        this.entityManager.setLoadedEntity(personalLabelProxy, EntityState.NEW);

        return Promise.resolve(personalLabelProxy);
    }

    public fromDto(dto: PersonalLabelDto): PersonalLabel {
        const personalLabelProxy = plainToInstance(PersonalLabel, dto);

        this.entityManager.setLoadedEntity(personalLabelProxy, EntityState.PERSISTED);

        return personalLabelProxy;
    }

    /**
     * No filter needed — the backend already scopes `/query/personal-label`
     * reads to the authenticated User's own rows (`OwnerReadScopedInterface`,
     * see `QueryAction`), so "all of mine" and "all" are the same request.
     */
    public async findAllMine(): Promise<PersonalLabel[]> {
        const dtos = await this.entityManager.findAllByQueryParameters<PersonalLabelDto>(this.entity.name, []);

        const entities = await Promise.all(dtos.map(dto => this._transformDtoToEntity(dto)));

        return entities.filter(ArrayHelper.notEmpty);
    }
}
